var _path, _rect, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 85H23C22.4477 85 22 84.5523 22 84V12C22 11.4477 22.4477 11 23 11H57V26C57 27.1046 57.8954 28 59 28H74V84C74 84.5523 73.5523 85 73 85ZM77 28V84C77 86.2091 75.2091 88 73 88H23C20.7909 88 19 86.2091 19 84V12C19 9.79086 20.7909 8 23 8H57H58.3431C59.404 8 60.4214 8.42143 61.1716 9.17157L68.5 16.5L75.8284 23.8284C76.5786 24.5786 77 25.596 77 26.6569V28Z",
    fill: "#952693"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37,
    width: 72,
    height: 32,
    rx: 4,
    fill: "#952693"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5191 41.9961L26.0801 49.4035L29.7082 41.9961H35.6039L29.3051 52.8973L36.091 64H29.893L26.1473 56.4246L22.4016 64H16.5059L22.9727 52.8973L16.6738 41.9961H22.5191Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7707 41.9961H44.4727L49.4109 57.3988H49.4949L54.4836 41.9961H61.2191V64H56.0961V58.541L56.5832 48.4965L56.4992 48.4797L51.1914 64H47.748L42.4906 48.6141L42.4066 48.6309L42.8938 58.541V64H37.7707V41.9961Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8023 41.9961V60.0695H79.2758V64H64.6793V41.9961H69.8023Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/XML.f60ee10f40b61e37152f94f8b8803a4e.svg";
export { ForwardRef as ReactComponent };